var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Do not edit this file, it is auto generated
 */
import { StyledSvgIcon } from '../../styles/svg-icon.styled';
export const SocialLinkedinIcon = (_a) => {
    var { size = 'md' } = _a, props = __rest(_a, ["size"]);
    return (_jsx(StyledSvgIcon, Object.assign({ xmlSpace: "preserve", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", "$size": size }, props, { children: _jsx("path", { d: "M3.402 11.501h5.399v16.455H3.402zM6.23 9.444c-1.8 0-3.085-1.286-3.085-2.828S4.43 3.787 6.23 3.787s3.085 1.286 3.085 2.828c0 1.543-1.285 2.829-3.085 2.829m22.626 18.769h-5.399v-8.742c0-2.314-.771-3.857-2.828-3.857-1.543 0-2.314 1.028-2.828 2.057-.257.257-.257.771-.257 1.286v9.256h-5.399V11.758h5.399v2.314c.771-1.028 2.057-2.828 4.885-2.828 3.6 0 6.428 2.314 6.428 7.456z" }) })));
};
